import PropTypes from 'prop-types'
import {
  TOOLTIP_POSITION_BOTTOM,
  TOOLTIP_POSITION_LEFT,
  TOOLTIP_POSITION_RIGHT,
  TOOLTIP_POSITION_TOP
} from '../../libraries/Tooltips'

export const TooltipProps = {
  'tooltip-position': PropTypes.oneOf([
    TOOLTIP_POSITION_BOTTOM,
    TOOLTIP_POSITION_LEFT,
    TOOLTIP_POSITION_RIGHT,
    TOOLTIP_POSITION_TOP
  ]),
  'tooltip-text': PropTypes.string
}
